module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GL - Greenland.6c96d430.svg";